import styled from 'styled-components';
import { Text } from 'ui-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 20px;
`;

export const TeamContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  row-gap: 24px;
  margin: 16px 8px;
`;

export const MemberContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-basis: 15%;
`;

export const MemberName = styled(Text).attrs({ type: 'body1' })`
  margin: 8px 0;
`;

export const MemberPortrait = styled.img`
  width: 200px;
  height: 200px;
  object-fit: cover;
  object-position: center;
`;
